// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__sNaX8","dark":"BaseLayout_dark__km+Xv","light":"BaseLayout_light__ldtJE","copyright":"BaseLayout_copyright__YpTrt"};